import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

interface Props {
  hasAccount?: boolean;
  backButton?: boolean;
  additionalClass?: string;
}


export const RedirectToLogin: FC<Props> = (props) => {
  const { hasAccount, backButton, additionalClass } = props;

  const { t } = useTranslation();
  const navigate = useNavigate();

  const loginUrl = '/auth/login';

	return (
    <>
      {
        hasAccount && (
          <div className={clsx(additionalClass)}>
            Already have an account?
            <span
              className="sign-in-link ms-1"
              onClick={(): void => navigate(loginUrl)}
            >
              {t('LOGIN.SIGN_IN')}
            </span>
          </div>
        )
      }

      {
        backButton && (
          <ButtonComponent
            buttonType={BUTTON_TYPE.FAKE_LINK}
            // buttonName={`← ${t('FORGOT_PASSWORD.G0_BACK')}`}
            onButtonClick={(): void => navigate(loginUrl)}
            additionalClass={clsx('btn-sm no-letter-spacing text-dark text-center', additionalClass)}
          >
            <>
              <FontAwesomeIcon icon={faArrowLeft} width={12} className="me-1 h-10px"/>
              {t('FORGOT_PASSWORD.G0_BACK')}
            </>
          </ButtonComponent>
        )
      }
    </>

	);
};
